// External libraries
import React from 'react';
import { useStoreState } from 'easy-peasy';
import { array, bool, func } from 'prop-types';
import {
  FloatingLabelSelect,
  LoadingElement,
} from '@checkout/react-components';

// Internal modules
import { getContent, getLocale } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

const CountryOfResidence = props => {
  useMountLogging('CountryOfResidence');
  const countryOfResidence = useStoreState(
    ({ form }) => form.countryOfResidence,
  );
  const selectOptions = useStoreState(({ api }) => {
    const { locale } = getLocale();
    return api.griffinMetadata.territories[locale];
  });

  // If the territories list is not populated yet (from the initial
  // data GraphQL call), show the loading element
  if (!selectOptions?.length) {
    return <LoadingElement />;
  }

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      focusHandler={props.focusHandler}
      id="countryOfResidence"
      label={getContent('fieldLabels.countryOfResidence')}
      name="countryOfResidence"
      required={true}
      selectOptions={selectOptions}
      {...countryOfResidence}
    />
  );
};

CountryOfResidence.propTypes = {
  blurHandler: func.isRequired,
  changeHandler: func.isRequired,
  focusHandler: func,
  selectOptions: array.isRequired,
  shouldFocusOnRender: bool,
};

export { CountryOfResidence };
